import { Notification, NotificationSize } from "hds-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useGetAppWideNotificationsQuery } from "../state/appWideNotificationSlice";

const IS_OPEN_KEY = "ulkoliikunta:isAppWideNotificationOpen";

type NotificationProps = {
  initialState?: boolean;
};

export function AppWideNotification({initialState}: NotificationProps) {
  const { data } = useGetAppWideNotificationsQuery();
  const notification = data?.[0];
  
  const notificationContentTranslations: Record<string, string | undefined> = {
    fi: notification ? notification.content.fi : '',
    sv: notification ? notification.content.sv : '',
    en: notification ? notification.content.en : '',
  };
  const notificationContentTitleTranslations: Record<string, string | undefined> = {
    fi: notification ? notification.title.fi : '',
    sv: notification ? notification.title.sv : '',
    en: notification ? notification.title.en : '',
  };

  const isNotificationEnabled = notification ? true : false;

  // Compute whether notification should be open based on sessionStorage and notification state
  const shouldBeOpen = isNotificationEnabled && 
    notification && 
    sessionStorage.getItem(IS_OPEN_KEY) !== notification.id.toString();

  const [isOpen, setIsOpen] = useState(initialState ?? shouldBeOpen);

  const {
    t,
    i18n: { language },
  } = useTranslation();

  const lang = language.split("-")[0];
  const notificationContent = notificationContentTranslations[lang];
  const notificationTitle = notificationContentTitleTranslations[lang];

  if (!isNotificationEnabled && notificationContent) {
    return null;
  }

  const handleClose = () => {
    setIsOpen(false);
    if (notification) {
      sessionStorage.setItem(IS_OPEN_KEY, notification.id.toString());
    }
  };

  return isOpen ? (
    <Notification
      label={notificationTitle}
      type="info"
      size={NotificationSize.Medium}
      dismissible
      closeButtonLabelText={t("APP.NOTIFICATION_CLOSE") as string}
      className="app-wide-notification"
      onClose={handleClose}
    >
      {notificationContent}
    </Notification>
  ) : null;
}

export default AppWideNotification;
